<mat-card>
  <h2 translate>request.title</h2>
  <form [formGroup]="requestDataAutosForm">
    <div fxFlex fxLayout="row wrap" class="form-wrapper">
      <div fxFlex="50" fxFlex.gt-sm="33">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="commercialProduct"
          [id]="'commercialProductAutosData'"
          [dataInput]="commercialProductList"
          [placeholder]="'request.commercialProduct'"
          [isRequired]="true"
          [showErrors]="requestDataAutosForm?.controls?.commercialProduct?.errors"
          (selectionChange)="onCommercialProductSelection()"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="33">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="vehicleType"
          [id]="'vehicleTypeAutosData'"
          [dataInput]="typeVehicleList"
          [placeholder]="'requestDataAutos.vehicleType'"
          [isRequired]="true"
          [showErrors]="requestDataAutosForm?.controls?.vehicleType?.errors"
          (selectionChange)="onTypeVehicleSelection()"
          [selectorIdProperty]="'sector'"
          [selectorValueProperty]="'description'"
        ></scf-custom-select-search>
      </div>

      <!--Row-->
      <div fxFlex="50" fxFlex.gt-sm="34">
        <mat-form-field yearMonthDirective fxFlex="100" appearance="outline">
          <mat-label translate>requestDataAutos.age</mat-label>
          <input
            id="carYearAutosData"
            matInput
            maxlength="7"
            [matDatepicker]="datepicker"
            formControlName="antCar"
            (dateChange)="onAntYearSelection()"
            [max]="currentDate"
            [min]="minAntYearDate"
            autocomplete="off"
          />
          <mat-error
            *ngIf="
              requestDataAutosForm.controls.antCar.hasError('required') &&
              !requestDataAutosForm.controls.antCar.hasError('matDatepickerParse')
            "
            translate
          >
            field.required
          </mat-error>
          <mat-error *ngIf="requestDataAutosForm.controls.antCar.hasError('matDatepickerMax')" translate>
            field.error.maxDateToCurrent
          </mat-error>
          <mat-error
            *ngIf="
              requestDataAutosForm.controls.antCar.hasError('antCarInvalid') ||
              requestDataAutosForm.controls.antCar.hasError('matDatepickerMin')
            "
            translate
          >
            field.error.antCar
          </mat-error>
          <mat-error *ngIf="requestDataAutosForm.controls.antCar.hasError('matDatepickerParse')" translate>
            field.error.parseDateMonth
          </mat-error>
          <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
          <mat-datepicker
            #datepicker
            startView="multi-year"
            (monthSelected)="chosenMonthHandler($event, datepicker)"
            (yearSelected)="chosenYearHandler($event)"
          ></mat-datepicker>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="brand"
          [id]="'brandAutosData'"
          [dataInput]="brandList"
          [placeholder]="'requestDataAutos.brand'"
          [isRequired]="!!this.mode"
          [showErrors]="requestDataAutosForm?.controls?.brand?.errors"
          (selectionChange)="onBrandSelection()"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="model"
          [id]="'modelAutosData'"
          [dataInput]="modelList"
          [placeholder]="'requestDataAutos.model'"
          [isRequired]="!!this.mode"
          [showErrors]="requestDataAutosForm?.controls?.model?.errors"
          (selectionChange)="onModelSelection()"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="50">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="version"
          [id]="'versionAutosData'"
          [dataInput]="versionList"
          [placeholder]="'requestDataAutos.version'"
          [isRequired]="!!this.mode"
          [showErrors]="requestDataAutosForm?.controls?.version?.errors"
          (selectionChange)="onVersionSelection()"
        ></scf-custom-select-search>
      </div>

      <!--Row-->
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>requestDataAutos.fuelType</mat-label>
          <mat-select id="fuelTypeId" formControlName="fuelType">
            <mat-option *ngFor="let fuelType of fuelTypeList" [value]="fuelType.id">{{ fuelType.value }}</mat-option>
          </mat-select>
          <mat-error *ngIf="requestDataAutosForm.controls.fuelType.hasError('required')" translate
            >field.required
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>requestDataAutos.numRack</mat-label>
          <input
            #numRack
            id="numRackAutosData"
            matInput
            formControlName="numRack"
            type="text"
            maxlength="17"
            (keypress)="alphanumericOnly($event, numRack)"
            (blur)="alphanumericAndSpecialCharacters($event, numRack)"
            autocomplete="off"
            (change)="changeValueForm()"
          />
          <mat-hint *ngIf="numRackIsOptional" translate>request.optional</mat-hint>
          <mat-error *ngIf="requestDataAutosForm.controls.numRack.hasError('required')" translate>
            field.required
          </mat-error>
          <mat-error *ngIf="requestDataAutosForm.controls.numRack.hasError('RackInvalid')" translate>
            field.RackInvalid
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>requestDataAutos.carRegistration</mat-label>
          <input
            #carRegistration
            id="carRegistrationAutosData"
            matInput
            formControlName="carRegistration"
            type="text"
            maxlength="7"
            (keypress)="alphanumericOnly($event, carRegistration)"
            (blur)="alphanumericAndSpecialCharacters($event, carRegistration)"
            autocomplete="off"
            (change)="changeValueForm()"
          />
          <mat-hint *ngIf="carRegistrationIsOptional" translate>request.optional</mat-hint>
          <mat-error *ngIf="requestDataAutosForm.controls.carRegistration.hasError('required')" translate>
            field.required
          </mat-error>
          <mat-error *ngIf="requestDataAutosForm.controls.carRegistration.hasError('RegistrationCarInvalid')" translate>
            field.RegistrationCarInvalid
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>requestDataAutos.priceVehicle</mat-label>
          <input
            id="priceVehicleAutosData"
            #priceVehicle
            matInput
            formControlName="priceVehicle"
            type="text"
            maxlength="12"
            (change)="calculateStart()"
            (keypress)="numberOnly($event, priceVehicle)"
            (blur)="transformAmount($event, priceVehicle)"
            autocomplete="off"
          />
          <mat-error *ngIf="requestDataAutosForm.controls.priceVehicle.hasError('required')" translate
            >field.required
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>request.requestedAmount</mat-label>
          <input
            id="requestedAmountAutosData"
            #requestedAmount
            matInput
            formControlName="requestedAmount"
            type="text"
            maxlength="12"
            (change)="calculateStart()"
            (keypress)="numberOnly($event, requestedAmount)"
            (blur)="transformAmount($event, requestedAmount)"
            autocomplete="off"
          />
          <mat-error *ngIf="requestDataAutosForm.controls.requestedAmount.hasError('required')" translate
            >field.required
          </mat-error>
          <mat-error *ngIf="requestDataAutosForm.controls.requestedAmount.hasError('requestedAmountInvalid')" translate>
            field.amount.invalid
          </mat-error>
        </mat-form-field>
      </div>

      <!--Row-->
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>request.start</mat-label>
          <input id="startAutosData" matInput formControlName="start" readonly />
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>request.term</mat-label>
          <input
            id="termAutosData"
            matInput
            #term
            formControlName="term"
            maxlength="3"
            (keypress)="numberOnly($event, priceVehicle)"
            autocomplete="off"
            (change)="changeValueForm()"
          />
          <mat-error *ngIf="requestDataAutosForm.controls.term.hasError('required')" translate
            >field.required
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="formPayment"
          [id]="'formPaymentAutosData'"
          [dataInput]="formPaymentList"
          [placeholder]="'requestDataAutos.modalityPayment'"
          [isRequired]="true"
          [showErrors]="requestDataAutosForm?.controls?.formPayment?.errors"
          (selectionChange)="changeValueForm()"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="expirationDay"
          [id]="'expirationDayAutosData'"
          [dataInput]="expirationDateList"
          [placeholder]="'request.expireDate'"
          [isRequired]="true"
          [showErrors]="requestDataAutosForm?.controls?.expirationDay?.errors"
          (selectionChange)="changeValueForm()"
        ></scf-custom-select-search>
      </div>

      <!--Row-->
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>requestDataAutos.firstMonth</mat-label>
          <input id="firstMonthAutosData" matInput formControlName="firstMonth" readonly autocomplete="off" />
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="tariffs"
          [id]="'tariffsAutosData'"
          [dataInput]="tariffsList"
          [placeholder]="'request.tariffs'"
          [isRequired]="true"
          [showErrors]="requestDataAutosForm?.controls?.tariffs?.errors"
          [selectorIdProperty]="'codigo'"
          [selectorValueProperty]="'descripcion'"
          (selectionChange)="changeValueForm()"
        ></scf-custom-select-search>
      </div>

      <!--Row-->

      <div fxFlex="50" fxFlex.gt-sm="25" *ngIf="mode === 'view'">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>quota</mat-label>
          <input id="quotaAutosData" matInput formControlName="quota" autocomplete="off" />
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25" *ngIf="mode === 'view'">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>requestFinance.insurance</mat-label>
          <input id="insuranceAutosData" matInput formControlName="insurance" autocomplete="off" />
        </mat-form-field>
      </div>
      <!-- end row view mode -->
      <div fxFlex="50" fxFlex.gt-sm="25">
        <div class="request__button-calculate">
          <button
            id="calculateAutosData"
            *ngIf="mode !== 'view'"
            color="primary"
            mat-flat-button
            (click)="calculate(true)"
            [disabled]="this.mode === 'view'"
          >
            <mat-label translate> request.buttonCalculate</mat-label>
          </button>
        </div>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25" fxLayout="row" fxLayoutAlign="start center" *ngIf="reference">
        <mat-label class="alignRef"
          >{{ 'requestDataAutos.valorRef' | translate }} {{ reference | transformNumber }}</mat-label
        >
      </div>
    </div>
  </form>
</mat-card>
